import { z } from "zod";
import type { ChangePasswordMessages } from "../types";

const createNewPasswordSchema = (messages: ChangePasswordMessages) =>
	z
		.string({ required_error: messages.passwordRequired })
		.min(8, messages.minPasssword)
		.max(64, messages.maxPasssword)
		.regex(/[A-Z]/, messages.upperLetter)
		.regex(/[a-z]/, messages.lowerLetter)
		.regex(/[0-9]/, messages.aNumber)
		.regex(/[^a-zA-Z0-9]/, messages.specialCharcter);

export const createChangePasswordSchema = (messages: ChangePasswordMessages) =>
	z
		.object({
			oldPassword: z
				.string({ required_error: messages.oldPasswordRequired })
				.min(1, messages.oldPasswordRequired),
			newPassword: createNewPasswordSchema(messages),
			confirmPassword: createNewPasswordSchema(messages),
		})
		.refine(data => data.newPassword === data.confirmPassword, {
			message: messages.passwordMismatch,
			path: ["confirmPassword"],
		});
